import Image from "next/legacy/image";

const perks = [
    {name: 'Pay with Points', icon: '/assets/images/club-member/perks/icon-1.svg', description: '₱40 = 1 Point', extra_description: null},
    {name: 'FREE Towing', icon: '/assets/images/club-member/perks/icon-2.svg', description: 'Currently available within Metro Manila', extra_description: null},
    {name: 'Regular Discounts', icon: '/assets/images/club-member/perks/icon-3.svg', description: '15% OFF on labor', extra_description: '10% OFF on parts and accessories'},
    {name: 'Exclusive Promos', icon: '/assets/images/club-member/perks/icon-4.svg', description: 'Exciting monthly promos on top of regular discounts!', extra_description: null},
];

export default function Perks(){
    return(
        <section id="perks" className='lg:scroll-mt-[150px] md:scroll-mt-[140px] sm:scroll-mt-[130px] scroll-mt-[80px] snap-normal snap-start w-full bg-white md:pt-12 pt-4 border-t border-gray-200'>
            <div className='max-w-screen-xl mx-auto md:px-12 px-4'>
                <h1 className='text-5xl text-center'>Save And Experience The Rapide Way!</h1>
                <div className='grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-4 py-8'>
                    {perks.map((perk, index) => {
                        return(
                            <div key={index} className='flex flex-col relative'>
                                <div className='relative lg:w-52 lg:h-52 md:w-32 md:h-32 w-24 h-24 mx-auto'>
                                    <Image
                                        alt={perk.name}
                                        src={perk.icon}
                                        layout="responsive"
                                        height={1000}
                                        width={1000}
                                        objectFit="contain"
                                    />
                                </div>
                                <div className='text-center'>
                                    <h1 className='text-xl font-bold'>{perk.name}</h1>
                                    <p className='font-semibold text-lg'>{perk.description}</p>
                                    {perk.extra_description && (
                                        <p className='font-semibold text-base'>{perk.extra_description}</p>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    );
}